$(document).ready(function(){
  $('body').on('click','.home_customer_review',function(){
    var $this = $(this);
    var ratting='';
    $(".popup_img").attr('src',$this.attr('data-image'));
    $(".popup_title").text($this.attr('data-title'));
    $(".popup_comment").text($this.attr('data-content'));
    $(".product_image").attr('src',$this.attr('data-product_img'));
    $(".product_title").text($this.attr('data-product_title'));
    $(".product_link").attr('href',$this.attr('data-product_url'));
    
    for(var i=0; i<$this.attr('data-rating');i++){
        ratting+='<i class="fa fa-star"></i>';
    }
    $(".popup_ratting").html(ratting);
    $(".custom-model-main").addClass('model-open');
    
  });

  $(".Click-here").on('click', function() {
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });

  $(".bossdaysale_target").on('click', function() {
    $(".bossdaysale_target").removeClass('active');
    $(this).addClass('active');
  }); 

  

  $(".review_btn").click(function(){
    $(this).hide();
    $(".home_customer_review").removeClass('hide-review');
    //$(".hide-review-dynamic").show();
    $('.home_review_main').masonry({
      // options...
      itemSelector: '.home_customer_review',
      //columnWidth: 10,
    });
  });
  

  $(function(){
    $('.home_review_main').masonry({
      // options...
      itemSelector: '.home_customer_review',
      //columnWidth: 10,
    });
  });


/******Boss day sale******/


  $(".bossdaysale_target").click(function() {
    var target_id = $(this).attr('data-target');
      $('html, body').animate({
          scrollTop: $("#"+target_id).offset().top -100
      }, 2000);
  });
  
  $('.slider_link').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }    
    ]
  });
  
});


